import React from 'react';

const colleges = [
  'Harvard University','Stanford University','Oxford University',
  'Cambridge University','Yale University','Princeton University','Columbia University',
];

export default function Colleges() {
  const items = [...colleges, ...colleges];
  return (
    <section id="colleges" className="section-sm bg-surface">
      <div className="max-w-content mx-auto text-center mb-12 reveal">
        <span className="label label-blue">Institutions</span>
        <h2 className="heading mt-5">Trusted by Leading <em style={{ color:'var(--blue)' }}>Institutions</em></h2>
        <div className="divider blue center wide mt-5" />
      </div>

      <div className="marquee-wrap">
        <div className="marquee-track">
          {items.map((name, i) => (
            <div key={i}
              className="flex items-center gap-3 mx-5 px-7 py-4 rounded-2xl shrink-0"
              style={{ background:'rgba(255,255,255,.04)', border:'1px solid rgba(255,255,255,.08)', minWidth:'210px' }}>
              {/* Small building icon */}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="shrink-0 opacity-40">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="white" strokeWidth="1.5"/>
                <path d="M9 22V12h6v10" stroke="white" strokeWidth="1.5"/>
              </svg>
              <span className="text-white/65 text-sm font-semibold whitespace-nowrap">{name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
